import {
  Wallet,
  TrendingUp,
  TrendingDown,
  MessageSquare,
  Copy,
  Trophy,
  Target,
  CheckCircle,
  Plus,
  Users,
  Flame,
  Eye,
  Newspaper,
  Star,
} from "lucide-react";
import type { EventType } from "./types";

// Per-event-type icon + color metadata used by the generic Default
// Row (and any future component that needs to badge an event by
// type). Most specific Rows render their own bespoke chrome and
// don't read this map — only fallback events (pnl_win, pnl_loss,
// follow, resolution, leaderboard_move, streak) actually consume it
// through DefaultRow today.
export const EVENT_STYLES: Record<
  EventType,
  { icon: any; iconBg: string; iconColor: string; badge: { icon: any; text: string; color: string } }
> = {
  whale_trade: {
    icon: Wallet,
    iconBg: "bg-gradient-to-br from-purple-500 to-pink-500",
    iconColor: "text-white",
    badge: { icon: Wallet, text: "BIG TRADE", color: "bg-purple-500/10 text-purple-500 border-purple-500/20" },
  },
  user_trade: {
    icon: TrendingUp,
    iconBg: "bg-gradient-to-br from-blue-500 to-cyan-500",
    iconColor: "text-white",
    badge: { icon: TrendingUp, text: "TRADE", color: "bg-blue-500/10 text-blue-500 border-blue-500/20" },
  },
  user_post: {
    icon: MessageSquare,
    iconBg: "bg-gradient-to-br from-gray-500 to-gray-600",
    iconColor: "text-white",
    badge: { icon: MessageSquare, text: "POST", color: "bg-gray-500/10 text-gray-500 border-gray-500/20" },
  },
  user_post_trade: {
    icon: TrendingUp,
    iconBg: "bg-emerald-500",
    iconColor: "text-gray-900",
    badge: { icon: TrendingUp, text: "TRADE", color: "bg-blue-500/10 text-blue-500 border-blue-500/20" },
  },
  user_post_opinion: {
    icon: MessageSquare,
    iconBg: "bg-gradient-to-br from-gray-600 to-gray-700",
    iconColor: "text-white",
    badge: { icon: MessageSquare, text: "OPINION", color: "bg-gray-500/10 text-gray-500 border-gray-500/20" },
  },
  copy_trade: {
    icon: Copy,
    iconBg: "bg-emerald-500",
    iconColor: "text-gray-900",
    badge: { icon: Copy, text: "COPY", color: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20" },
  },
  pnl_win: {
    icon: Trophy,
    iconBg: "bg-gradient-to-br from-emerald-500 to-green-500",
    iconColor: "text-white",
    badge: { icon: Trophy, text: "WIN", color: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20" },
  },
  pnl_loss: {
    icon: TrendingDown,
    iconBg: "bg-gradient-to-br from-red-500 to-orange-500",
    iconColor: "text-white",
    badge: { icon: TrendingDown, text: "LOSS", color: "bg-red-500/10 text-red-500 border-red-500/20" },
  },
  market_move: {
    icon: Target,
    iconBg: "bg-gradient-to-br from-orange-500 to-yellow-500",
    iconColor: "text-white",
    badge: { icon: Target, text: "MOVE", color: "bg-orange-500/10 text-orange-500 border-orange-500/20" },
  },
  resolution: {
    icon: CheckCircle,
    iconBg: "bg-gradient-to-br from-indigo-500 to-purple-500",
    iconColor: "text-white",
    badge: { icon: CheckCircle, text: "RESOLVED", color: "bg-indigo-500/10 text-indigo-500 border-indigo-500/20" },
  },
  leaderboard_move: {
    icon: Trophy,
    iconBg: "bg-gradient-to-br from-amber-500 to-orange-500",
    iconColor: "text-white",
    badge: { icon: Trophy, text: "LEADERBOARD", color: "bg-amber-500/10 text-amber-500 border-amber-500/20" },
  },
  new_market: {
    icon: Plus,
    iconBg: "bg-gradient-to-br from-cyan-500 to-blue-500",
    iconColor: "text-white",
    badge: { icon: Plus, text: "NEW", color: "bg-cyan-500/10 text-cyan-500 border-cyan-500/20" },
  },
  new_event: {
    icon: Trophy,
    iconBg: "bg-gradient-to-br from-violet-500 to-purple-500",
    iconColor: "text-white",
    badge: { icon: Star, text: "EVENT", color: "bg-purple-500/10 text-purple-500 border-purple-500/20" },
  },
  follow: {
    icon: Users,
    iconBg: "bg-gradient-to-br from-pink-500 to-rose-500",
    iconColor: "text-white",
    badge: { icon: Users, text: "FOLLOW", color: "bg-pink-500/10 text-pink-500 border-pink-500/20" },
  },
  streak: {
    icon: Flame,
    iconBg: "bg-emerald-500",
    iconColor: "text-gray-900",
    badge: { icon: Flame, text: "STREAK", color: "bg-amber-500/10 text-amber-500 border-amber-500/20" },
  },
  tracker_trade: {
    icon: Eye,
    iconBg: "bg-gradient-to-br from-pink-500 to-orange-500",
    iconColor: "text-white",
    badge: { icon: Eye, text: "WATCHLIST", color: "bg-pink-500/10 text-pink-500 border-pink-500/20" },
  },
  blog_article: {
    icon: Newspaper,
    iconBg: "bg-gradient-to-br from-sky-500 to-indigo-500",
    iconColor: "text-white",
    badge: { icon: Newspaper, text: "ARTICLE", color: "bg-sky-500/10 text-sky-500 border-sky-500/20" },
  },
};
